
import { useBlockedCompanies } from "@/hooks/useBlockedCompanies";
import { BlockedCompaniesList } from "@/components/dashboard/blocked/BlockedCompaniesList";

const BlockedCompanies = () => {
  const { blockedCompanies, isLoading } = useBlockedCompanies(undefined);

  return (
    <div className="container mx-auto p-6">
      <h1 className="text-2xl font-semibold mb-6">Blocked Companies</h1>
      <BlockedCompaniesList 
        companies={blockedCompanies || []}
        isLoading={isLoading}
      />
    </div>
  );
};

export default BlockedCompanies;
